var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportantInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 232,
    viewBox: "0 0 398 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.956 0C307.21 0 395.228 86.9402 397.448 195.033H0.464355C2.68442 86.9402 90.7022 0 198.956 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.341 46.2532C281.577 46.2532 348.242 113.054 348.242 195.457L348.239 195.035L50.4404 195.034C50.6659 113.649 115.919 47.5885 196.879 46.2732L199.341 46.2532Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.532 195.034C274.369 195.034 206.651 195.034 97.3804 195.034C97.3804 138.836 142.857 93.2773 198.956 93.2773C255.055 93.2773 300.532 138.836 300.532 195.034Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.931 175.467H254.792V231.141H143.931V175.467Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.792 175.467H143.931L198.335 127.526L254.792 175.467Z",
    fill: "#F6F9FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.785 226.888V147.244H246.708V226.888H152.785Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208 162.667H192C190.527 162.667 189.333 163.861 189.333 165.333V181.333C189.333 182.806 190.527 184 192 184H208C209.473 184 210.667 182.806 210.667 181.333V165.333C210.667 163.861 209.473 162.667 208 162.667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.333 160V165.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.667 160V165.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M189.333 170.667H210.667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.333 176H194.667V178.667H197.333V176Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.792 175.467L143.931 231.141H254.792V175.467Z",
    fill: "#ECF3FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.931 175.467L254.792 231.141H143.931V175.467Z",
    fill: "#F6F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantInfo);
export default __webpack_public_path__ + "static/media/importantInfo.1cfcfc5930ae49a5f1e6efce83d75a65.svg";
export { ForwardRef as ReactComponent };